// The new, streamlined interface (9 October 2026): evenings and the register.
// Texts the classic screen already had (schedules, ratings, calibration) are
// still read from `projector.soirees` and `projector.commun`.
export default {
  titre: 'Evenings',
  sousTitre: 'The evening projected the day before, sealed, then checked against the published ratings',
  vues: 'Evening views',
  projeter: 'Project an evening',
  scores: {
    aria: 'The scoreboard',
    scellees: 'sealed projections',
    confrontees: 'checked against reality',
    ecart: 'average gap with the ratings, {cible}',
    brut: 'raw: {v} pts',
    fourchette: 'within the projected range',
    aVenir: 'to come',
  },
  registre: {
    dansLaFourchette: 'within the projected range',
    horsFourchette: 'outside the projected range',
  },
  vide: {
    titre: 'Your register is empty',
    texte: 'Every projection is sealed before broadcast: no one can touch it up afterwards. This register is what proves, evening after evening, what the projections are worth.',
    etapes: {
      choisir: {
        titre: 'Choose the evening',
        texte: 'The evening’s schedule is fetched: every channel, every programme up against yours.',
      },
      sceller: {
        titre: 'Project and seal',
        texte: 'The day before, the twins spend the evening in front of the TV; the projected audience share is sealed.',
      },
      confronter: {
        titre: 'Check',
        texte: 'The next day, the published ratings arrive: the gap goes into the register, with no touching up possible.',
      },
    },
  },
  soirees: {
    nouvelle: 'A new evening',
    jour: 'Day',
    creneau: 'Slot',
    relevees: 'Fetched evenings',
    choisir: 'Choose a fetched evening, or fetch a new evening’s schedule: every programme up against yours, then “Project its audience”.',
    actions: 'Actions',
  },
}
